module.exports = __webpack_public_path__ + "static/nextjs-18c2cbef91dc0d416192ca86e6d2d1f5.png";